<template>
  <div class="page-form page-base">
    <h3 class="title">合同信息</h3>
    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button name="返回" @click="$router.go(-1)" />
        <template v-if="isShow">
          <form-button v-if="isModify" name="修改" @click="isModify = false" />
          <form-button v-if="!isModify" name="显示" @click="isModify = true" />
        </template>
        <template v-if="!isModify">
          <form-button v-if="isEdit" name="提交" @click="saveData('SUBMIT')" />
          <form-button v-if="conditions.stacode === 'E003'" name="审核通过" @click="saveData('AUDIT')" />
          <form-button v-if="conditions.stacode === 'E003'" name="审核拒绝" @click="saveData('REJECT')" />
          <form-button v-if="conditions.stacode === 'E002' || conditions.stacode === 'E003' || conditions.stacode === 'E004'" name="取消" @click="saveData('CANCEL')" />
          <form-button v-if="mode == 'edit'" @click="newPage">新建</form-button>
        </template>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :disabled="!isEdit"
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="合同单号">
              <el-input v-model="conditions.cntrno" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="合同编号" prop="cnrtln">
              <el-input v-model="conditions.cnrtln" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="合同名称" prop="cntrname">
              <el-select v-model="conditions.cntrname" clearable placeholder="">
                <el-option
                  v-for="item in selectDataOptions['contractName']"
                  :key="item.VALUE_ID"
                  :label="item.VALUE_KT"
                  :value="item.VALUE_ID"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号" prop="customer">
              <wly-input
                v-model="conditions.customer"
                input-type="customer"
                :disabled="!isEdit"
                @enter="handleEnter"
                @handleSuffixClick="openDialog"
              />
              <!-- <el-input v-model="conditions.customer" suffix-icon="el-icon-more" placeholder="请输入" @focus="openDialog" /> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input v-model="conditions.name1" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.customer_type" disabled placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <el-select v-model="conditions.sal_center" placeholder="" @change="salChange">
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="plan_type">
              <el-select v-model="conditions.plan_type" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="合同年度" prop="contr_year">
              <el-date-picker
                v-model="conditions.contr_year"
                type="year"
                format="yyyy"
                value-format="yyyy"
                :clearable="false"
                @change="contrYearChange"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.zzfld00003e" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约审批单号" prop="approval_no">
              <el-input
                v-model="conditions.approval_no"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="地址">
              <el-input v-model="conditions.address" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input v-model="conditions.remark" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="合同金额/数量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="起始日期" prop="cotr_start">
              <el-date-picker
                v-model="conditions.cotr_start"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="到期日期" prop="cont_end">
              <el-date-picker
                v-model="conditions.cont_end"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终止日期" prop="cont_close">
              <el-date-picker
                v-model="conditions.cont_close"
                type="date"
                value-format="yyyyMMdd"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="签约方式" prop="sign_status">
              <el-select v-model="conditions.sign_status" placeholder="">
                <el-option
                  v-for="item in selectDataOptions['A0010']"
                  :key="item.value"
                  :value="item.value"
                  :label="item.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="总数量(件)" prop="cotr_qty">
              <el-input v-model="conditions.cotr_qty" placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="总金额(万元)">
              <el-input v-model="conditions.cotr_amt" placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="合同状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.name_first" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建时间">
              <el-date-picker v-model="conditions.datum" value-format="yyyyMMdd" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input v-model="conditions.audit_comment" type="textarea" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="销售区域设置" :custome-config="() => vxeShowCustom('gridOptionArea')">
        <template v-if="isEdit" #button>
          <table-button name="add" tip="新增" @click="insertArea" />
          <table-button name="delete" tip="删除" @click="removeArea" />
        </template>
        <vxe-grid
          ref="gridOptionArea"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionArea.columns"
          :data="gridOptionArea.data"
        >
          <template #MARKET_DES="{row}">
            <wly-input
              v-model="row.MARKET_DES"
              input-type="customer"
              disabled-enter
              :disabled="!isEdit"
              @handleSuffixClick="openDialogArea(row, 'market')"
            />
          </template>
          <template #MARKET_QUAN="{row}">
            <el-input v-model="row.MARKET_QUAN" size="mini" :disabled="!isEdit" />
          </template>
          <template #CHFL_DES="{row}">
            <wly-input
              v-model="row.CHFL_DES"
              input-type="customer"
              disabled-enter
              :disabled="!isEdit"
              @handleSuffixClick="openDialogArea(row, 'chfl')"
            />
          </template>
          <template #REGN_NAME="{row}">
            <wly-input
              v-model="row.REGN_NAME"
              input-type="customer"
              disabled-enter
              :disabled="!isEdit"
              @handleSuffixClick="openDialogArea(row, 'region')"
            />
          </template>
          <template #CITY_NAME="{row}">
            <wly-input
              v-model="row.CITY_NAME"
              input-type="customer"
              disabled-enter
              :disabled="!isEdit"
              @handleSuffixClick="openDialogArea(row, 'city')"
            />
          </template>
          <template #STREET_NAME="{row}">
            <wly-input
              v-model="row.STREET_NAME"
              input-type="customer"
              disabled-enter
              :disabled="!isEdit"
              @handleSuffixClick="openDialogArea(row, 'street')"
            />
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="销售渠道设置" :show-custome="false">
        <el-checkbox-group v-model="chanelCheckList">
          <el-row>
            <el-col v-for="item in channelList" :key="item.CHANNEL" :lg="6" :md="8">
              <el-checkbox :disabled="!isEdit || conditions.cntrname === 'V002'" :label="item.CHANNEL">{{ item.CHL_NAME }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>

      <TableCommon title="存货分类设置" :show-custome="false">
        <el-checkbox-group v-model="chflCheckList">
          <el-row>
            <el-col v-for="item in selectDataOptions['contractChfl']" :key="item.VALUE_ID" :lg="6" :md="8">
              <el-checkbox :disabled="!isEdit" :label="item.VALUE_ID">{{ item.VALUE_KT }}</el-checkbox>
            </el-col>
          </el-row>
        </el-checkbox-group>
      </TableCommon>

      <!-- <TableCommon title="存货分类按月明细" :custome-config="() => vxeShowCustom('gridOptionChfl')">
        <vxe-grid
          ref="gridOptionChfl"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :edit-rules="chflRule"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionChfl.columns"
          :data="gridOptionChfl.data"
        >
          <template #CHFL="{ row }">
            <span>{{ filterChfl(row.CHFL) }}</span>
          </template>
          <template #QUANTITY="{ row }">
            <el-input v-if="isEdit" v-model="row.QUANTITY" size="mini" />
            <span v-else>{{ row.QUANTITY }}</span>
          </template>
          <template #AMOUNT="{ row }">
            <el-input v-if="isEdit" v-model="row.AMOUNT" size="mini" />
            <span v-else>{{ row.AMOUNT }}</span>

          </template>
          <template #AMOUNT_OUTER="{ row }">
            <el-input v-if="isEdit" v-model="row.AMOUNT_OUTER" size="mini" />
            <span v-else>{{ row.AMOUNT_OUTER }}</span>

          </template>
          <template #QUANTITY_OUTER="{ row }">
            <el-input v-if="isEdit" v-model="row.QUANTITY_OUTER" size="mini" />
            <span v-else>{{ row.QUANTITY_OUTER }}</span>

          </template>
          <template #REMARK="{ row }">
            <el-input v-if="isEdit" v-model="row.REMARK" size="mini" />
            <span v-else>{{ row.REMARK }}</span>

          </template>
        </vxe-grid>
      </TableCommon> -->

      <TableCommon title="变更记录" :custome-config="() => vxeShowCustom('gridOptionHistory')">
        <vxe-grid
          ref="gridOptionHistory"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionHistory.columns"
          :data="gridOptionHistory.data"
        />
      </TableCommon>
    </div>

    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="客户选择"
      width="70%"
    >
      <client-select v-if="showDialog" ref="clientSelect" />
      <div slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-dialogDrag
      :visible.sync="showMarket"
      :title="dialogOptions[dialogType]"
      width="70%"
    >
      <template v-if="showMarket">
        <Market v-if="dialogType === 'market'" ref="dialogComponent" />
        <Chfl v-if="dialogType === 'chfl'" ref="dialogComponent" />
        <Region v-if="dialogType === 'region'" ref="dialogComponent" />
        <City v-if="dialogType === 'city'" ref="dialogComponent" :region="currentArea.REGION" />
        <Street v-if="dialogType === 'street'" ref="dialogComponent" :city="currentArea.CITY_CODE" />
      </template>
      <div slot="footer">
        <el-button size="small" @click="showMarket = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitMarket">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiSapClientFindInfo } from '@/api/common'

import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import Market from '@/components/dialog/Market.vue'
import Chfl from '@/components/dialog/Chfl.vue'
import Region from '../components/Region.vue'
import City from '../components/City.vue'
import Street from '../components/Street.vue'
import { apiGetContractDetail, apiGetContractQd, apiContractCreate, apiGetContractName, apiGetContractChfl } from '@/api/sap/contract'
export default {
  components: { ClientSelect, Market, Chfl, Region, City, Street },
  data() {
    const rules = {
      cnrtln: [{ required: true, message: '请输入合同编码', trigger: 'blur' }],
      cntrname: [{ required: true, message: '请选择合同名称', trigger: 'change' }],
      sal_center: [{ required: true, message: '请选择营销单元', trigger: 'change' }],
      // plan_type: [{ required: true, message: '请选择计划类型', trigger: 'change' }],
      customer: [{ required: true, message: '请选择客户', trigger: 'change' }],
      // cont_close: [{ required: true, message: '请选择终止日期', trigger: 'change' }],
      cont_end: [{ required: true, message: '请选择到期日期', trigger: 'change' }],
      cotr_qty: [{ required: true, message: '请输入总数量', trigger: 'change' }],
      cotr_start: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
      sign_status: [{ required: true, message: '请选择签约方式', trigger: 'change' }],
      contr_year: [{ required: true, message: '请选择合同年度', trigger: 'change' }]
    }
    return {
      rules,
      chflRule: {
        QUANTITY: [{ required: true }]
      },
      showDialog: false,
      showMarket: false,
      dialogType: '',
      dialogOptions: {
        chfl: '存货分类选择',
        market: '卖场选择',
        region: '经营区域/省份/直销市',
        city: '经营区域/城市/地区'
      },
      chflOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'VALUE_ID', title: '存货分类编码', width: 180 },
          { field: 'VALUE_KT', title: '存货分类描述', width: 180 }
        ]
      },
      loading: false,
      errorList: [],
      mode: 'add',
      isModify: true,
      conditions: {
        name_first: '',
        datum: '',
        status: '新建',
        stacode: 'E001',
        cntrno: '',
        cnrtln: '',
        cntrname: '',
        customer: '',
        name1: '',
        customer_type: '',
        sal_center: '',
        sign_status: '',
        cotr_start: '',
        cont_end: '',
        cont_close: '',
        contr_year: new Date().getFullYear().toString(),
        cotr_qty: '',
        cotr_amt: '',
        address: '',
        plan_type: '',
        zzfld00003e: '',
        zzfld00003e_textview: '',
        remark: '',
        audit_comment: ''
      },
      chanelCheckList: [],
      chflCheckList: [],
      selectDataOptions: {},
      gridOptionArea: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'CHFL_DES', title: '存货分类', slots: { default: 'CHFL_DES' }, visible: false, width: 180 },
          { field: 'MARKET_DES', title: '卖场', slots: { default: 'MARKET_DES' }, width: 300, visible: false },
          { field: 'MARKET_QUAN', title: '门店数量', slots: { default: 'MARKET_QUAN' }, width: 120, visible: false },
          { field: 'REGN_NAME', title: '经营区域/省份/直销市', slots: { default: 'REGN_NAME' }},
          { field: 'CITY_NAME', title: '经营区域/城市/地区', slots: { default: 'CITY_NAME' }},
          { field: 'STREET_NAME', title: '经营区域/区县', slots: { default: 'STREET_NAME' }}
        ],
        data: []
      },
      gridOptionChfl: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'CHFL', title: '存货分类', slots: { default: 'CHFL' }},
          { field: 'YEAR_MONTH', title: '年月', formatter: ({ cellValue }) => cellValue.replace(/^(\d{4})(\d{2})/, `$1-$2`) },
          { field: 'UNIT', title: '单位' },
          { field: 'QUANTITY', title: '计划内数量(件)', slots: { default: 'QUANTITY' }, editRender: {}},
          { field: 'AMOUNT', title: '金额(万元)', slots: { default: 'AMOUNT' }},
          { field: 'QUANTITY_OUTER', title: '计划外数量(件)', slots: { default: 'QUANTITY_OUTER' }},
          { field: 'AMOUNT_OUTER', title: '计划外金额(万元)', slots: { default: 'AMOUNT_OUTER' }},
          { field: 'REMARK', title: '备注', slots: { default: 'REMARK' }}
        ],
        data: []
      },
      gridOptionHistory: {
        columns: [
          { field: 'NAME_FIRST', title: '操作人' },
          { field: 'STATUS', title: '状态' },
          { field: 'MDATE', title: '变更日期' },
          { field: 'MTIME', title: '变更时间' }
        ],
        data: []
      },
      currentArea: null,
      contract: {},
      lt_itmb: []
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo']),
    isEdit() {
      return this.conditions.stacode === 'E001' || !this.isModify
    },
    isShow(){
      const arr = ['E002','E003','E004']
      const roles = ['WLY002','WLYALL']
      if(arr.indexOf(this.conditions.stacode) > -1){
        return roles.indexOf(this.role.ROLE) > -1
      }
    },
    channelList() {
      if (this.conditions.cntrname === 'V002') {
        return this.selectDataOptions['contractQd']?.filter(v => v.CHANNEL === 'V004') || []
      } else {
        return this.selectDataOptions['contractQd'] || []
      }
    }
  },
  watch: {
    'conditions.cntrname': {
      handler(nv) {
        if (nv === 'V002') {
          this.gridOptionArea.columns.forEach((item, i) => {
            // 如果合同名称为  V002 时，显示这几个字段
            if (['CHFL_DES', 'MARKET_DES', 'MARKET_QUAN'].includes(item.field)) {
              item.visible = true
              this.gridOptionArea.columns.splice(i, 1, item)
            }
          })
          this.chanelCheckList = ['V004']
        } else {
          this.gridOptionArea.columns.forEach((item, i) => {
            // 如果合同名称不为  V002 时，隐藏这几个字段
            if (['CHFL_DES', 'MARKET_DES', 'MARKET_QUAN'].includes(item.field)) {
              item.visible = false
              this.gridOptionArea.columns.splice(i, 1, item)
            }
          })
          this.gridOptionArea.data.forEach(item => {
            item['CHFL'] = ''
            item['MARKET'] = ''
            item['MARKET_QUAN'] = ''
            item['CHFL_DES'] = ''
            item['MARKET_DES'] = ''
          })
          this.chanelCheckList = this.lt_itmb.filter(v => v.SEL === 'X').map(v => v.CHANNEL)
        }
      }
    }
  },
  created() {
    this.init()
    const { id } = this.$route.query
    if (id) {
      this.mode = 'edit'
      // 请求合同详情接口
      this.getDetail(id)
    }
  },
  methods: {
    newPage() {
      this.$router.replace('/wly/contract/edit')
    },
    async getDetail(id) {
      const params = {
        iv_cntrno: id,
        mv_role: this.role.USER_BP
      }
      const res = await apiGetContractDetail(params)
      Object.keys(res.LS_HEAD).forEach(key => {
        this.conditions[key.toLowerCase()] = res.LS_HEAD[key]
      })
      this.initCustome()
      this.gridOptionArea.data = res.LT_ITMA
      this.gridOptionChfl.data = res.LT_ITME
      this.gridOptionHistory.data = res.LT_ITMC
      this.chflCheckList = res.LT_ITMD.filter(v => v.SEL === 'X').map(v => v.VALUE_ID)
      this.chanelCheckList = res.LT_ITMB.filter(v => v.SEL === 'X').map(v => v.CHANNEL)
      this.lt_itmb = res.LT_ITMB
    },

    // 初始化客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: this.conditions.customer,
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.role.USER_BP
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0].yxdy)
      this.$set(this.selectDataOptions, 'addressList', data[0].address)
    },
    async init() {
      this.getSelectDictDataOrigin('A0002')
      this.getSelectDictDataOrigin('A0048')
      // 销售渠道
      this.getSelectDictDataOrigin('A0050')
      this.getSelectDictDataOrigin('A0010')
      this.getSelectDictDataOrigin('A0009')
      this.getContractName()
      this.getContractChfl()
      this.getContractQd()
    },
    // 合同名称
    async getContractName() {
      const { DATA } = await apiGetContractName()
      this.$set(this.selectDataOptions, 'contractName', DATA)
    },
    // 存货分类
    async getContractChfl() {
      const { DATA } = await apiGetContractChfl()
      this.$set(this.selectDataOptions, 'contractChfl', DATA)
    },
    // 渠道类型
    async getContractQd() {
      const { DATA } = await apiGetContractQd()
      this.$set(this.selectDataOptions, 'contractQd', DATA)
    },
    openDialog(e) {
      e.target.blur()
      this.showDialog = true
    },
    openDialogArea(row, type) {
      this.currentArea = row
      this.dialogType = type
      this.showMarket = true
    },
    async handleSubmitMarket() {
      const data = await this.$refs.dialogComponent.submitForm()
      if (data.length) {
        // 查询到选择行的index
        const idx = this.gridOptionArea.data.findIndex(item => item._X_ID === this.currentArea._X_ID)
        // 需要替换的数据
        const res = []
        let i = 0
        // 选择卖场
        if (this.dialogType === 'market') {
          while (i < data.length) {
            // 复制行并且删除行唯一标识 _X_ID
            const row = { ...this.currentArea }
            delete row._X_ID
            row.MARKET = data[i].VALUE_ID
            row.MARKET_DES = data[i].VALUE_KT
            res.push(row)
            i++
          }
        } else if (this.dialogType === 'chfl') {
          while (i < data.length) {
            const row = { ...this.currentArea }
            delete row._X_ID
            row.CHFL = data[i].VALUE_ID
            row.CHFL_DES = data[i].VALUE_KT
            res.push(row)
            i++
          }
        } else if (this.dialogType === 'region') {
          while (i < data.length) {
            const row = { ...this.currentArea }
            delete row._X_ID
            row.REGION = data[i].BLAND
            row.REGN_NAME = data[i].BEZEI
            // 需要清空 市 区 字段
            row.CITY_CODE = ''
            row.CITY_NAME = ''
            row.STREET = ''
            row.STREET_NAME = ''
            res.push(row)
            i++
          }
        } else if (this.dialogType === 'city') {
          while (i < data.length) {
            const row = { ...this.currentArea }
            delete row._X_ID
            row.CITY_CODE = data[i].CITY_CODE
            row.CITY_NAME = data[i].CITY_NAME
            // 需要清空区 字段
            row.STREET = ''
            row.STREET_NAME = ''
            res.push(row)
            i++
          }
        } else if (this.dialogType === 'street') {
          while (i < data.length) {
            const row = { ...this.currentArea }
            delete row._X_ID
            row.STREET = data[i].STRT_CODE
            row.STREET_NAME = data[i].MC_STREET
            res.push(row)
            i++
          }
        }
        this.gridOptionArea.data.splice(idx, 1, ...res)
      }
      this.showMarket = false
    },
    async handleSubmit() {
      const data = await this.$refs.clientSelect.submitForm()
      if (!data) return

      this.conditions.customer = data.partner
      this.conditions.name1 = data.name_org1
      this.conditions.customer_type = data.zzfld000016
      this.$set(this.selectDataOptions, 'orgList', data.orgList)
      this.$set(this.selectDataOptions, 'addressList', data.addressList)
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      switch (type) {
        case 'customer':
          this.conditions.customer = data.partner
          this.conditions.name1 = data.name_org1
          this.conditions.customer_type = data.zzfld000016
          this.$set(this.selectDataOptions, 'orgList', data.orgList)
          this.$set(this.selectDataOptions, 'addressList', data.addressList)
          break
      }
    },
    salChange(e) {
      if (e) {
        const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
        this.conditions.zzfld00003e = checkedData.mc_short_jd
      } else {
        this.conditions.zzfld00003e = ''
      }
    },
    insertArea() {
      const row = {
        REGION: '',
        REGN_NAME: '',
        CITY_CODE: '',
        CITY_NAME: '',
        STREET: '',
        STREET_NAME: '',
        MARKET: '',
        MARKET_DES: '',
        MARKET_QUAN: '',
        CHFL: '',
        CHFL_DES: '',
        cityList: [],
        regionList: this.selectDataOptions['regionList'],
        streetList: []
      }
      this.gridOptionArea.data.unshift(row)
    },
    removeArea() {
      const checkList = this.$refs.gridOptionArea.getCheckboxRecords()

      // 直接删除
      checkList.forEach(item => {
        const index = this.gridOptionArea.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptionArea.data.splice(index, 1)
      })
    },
    saveData(mode) {
      this.$refs.form.validate(async(val, err) => {
        if (val) {
          const itmb = this.selectDataOptions.contractQd.filter(v => this.chanelCheckList.includes(v.CHANNEL)).map(v => {
            v.sel = 'X'
            return v
          })
          const itmd = this.selectDataOptions.contractChfl.filter(v => this.chflCheckList.includes(v.VALUE_ID)).map(v => {
            v.sel = 'X'
            return v
          })
          // try {
          //   this.gridOptionChfl.data.forEach(item => {
          //     if (item.QUANTITY < 0) {
          //       throw new Error('请输入必输项：计划内数量！')
          //     }
          //     if (!Number.isInteger(item.QUANTITY - 0)) {
          //       throw new Error('存货分类按月明细中计划内数量必须为整数！')
          //     }
          //   })
          // } catch (e) {
          //   this.errorList = [e.message]
          //   return
          // }

          const params = {
            iv_mode: mode,
            user_bp: this.role.USER_BP,
            head: this.conditions,
            itma: this.gridOptionArea.data,
            itmb: itmb,
            itmd: itmd,
            itme: this.gridOptionChfl.data,
            itmc: this.gridOptionHistory.data
          }
          const res = await apiContractCreate(params)
          if (res.MSGTYPE === 'S') {
            this.isModify = true

            this.errorList = []
            this.$message.success(res.MESSAGE)
            Object.keys(res.DATA.HEAD).forEach(key => {
              this.conditions[key.toLowerCase()] = res.DATA.HEAD[key]
            })
            this.gridOptionArea.data = res.DATA.ITMA
            this.gridOptionChfl.data = res.DATA.ITME
            this.gridOptionHistory.data = res.DATA.ITMC
            this.lt_itmb = res.DATA.LT_ITMB
          } else {
            this.errorList.push(res.MESSAGE)
          }
        } else {
          this.errorList = [`有${Object.values(err).length}项必填项目未填写`]
          return false
        }
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/contract-manage/check/contractDetail.vue